import script from "./AI.vue?vue&type=script&setup=true&lang=js"
export * from "./AI.vue?vue&type=script&setup=true&lang=js"

import "./AI.vue?vue&type=style&index=0&id=c6738d1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6738d1a"]])

export default __exports__